export default function Skeleton() {
  return {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          animation: 'skeletonOpacityPulse 1.4s ease-in-out infinite',
          '@keyframes skeletonOpacityPulse': {
            '0%': { opacity: 0.55 },
            '50%': { opacity: 1 },
            '100%': { opacity: 0.55 },
          },
        },
      },
    },
  };
}
